import React from "react";
import { Code2, Gamepad2, Sparkles, Lightbulb, Wand2 } from "lucide-react";

const FACTS = [
  {
    Icon: Code2,
    title: "Builder at heart",
    blurb: "I love turning a half-formed idea into something real you can click.",
  },
  {
    Icon: Gamepad2,
    title: "Board games by night",
    blurb: "Give me a table, some meeples, and a few good friends.",
  },
  {
    Icon: Sparkles,
    title: "Tinkerer always",
    blurb: "This site is my sandbox for silly little projects and half-ideas.",
  },
  {
    Icon: Lightbulb,
    title: "Powered by imagination",
    blurb: "The best projects start with a 'what if...' and a bit of wonder.",
  },
];

const About = () => {
  return (
    <div className="relative min-h-[calc(100vh-4rem)] overflow-hidden bg-dreamy">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-32 -top-24 h-96 w-96 rounded-full bg-primary/15 blur-3xl animate-aurora"
      />
      <Sparkles
        aria-hidden
        className="pointer-events-none absolute right-10 top-28 h-6 w-6 text-primary/30 animate-drift"
      />

      <div className="container relative mx-auto max-w-3xl px-4 py-20">
        <p className="inline-flex items-center gap-1.5 text-sm font-medium text-primary">
          <Wand2 className="h-4 w-4" />
          a little about me
        </p>
        <h1 className="mt-3 text-4xl font-bold tracking-tight sm:text-5xl">
          Hey, I'm <span className="text-gold-shimmer">Keyoni</span>.
        </h1>
        <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
          Truly, this site is just my playground for silly little projects — a
          place to dream things up, break a few of them, and have a bit of fun
          on the web.
        </p>

        <div className="mt-12 grid gap-4 sm:grid-cols-2">
          {FACTS.map(({ Icon, title, blurb }) => (
            <div
              key={title}
              className="group flex flex-col gap-3 rounded-xl border border-border bg-card/70 p-5 backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-primary/60 hover:glow-gold"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground group-hover:animate-wiggle">
                <Icon className="h-5 w-5" />
              </span>
              <div>
                <h2 className="font-semibold text-card-foreground">{title}</h2>
                <p className="mt-1 text-sm text-muted-foreground">{blurb}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
